import React from 'react'

import isDOMAvailable from 'utils/isDOMAvailable'

import Badge from 'components/atoms/Badge'
import Backdrop from 'components/atoms/Backdrop'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'

import triggerEvent from 'utils/dataLayer'
import config from 'config'

const { assets_url: assetsUrl } = config

const PopupMenu = ({ items, close }) => (
  <div className="popup-menu">
    <div className="popup-menu-inner">
      {items.map((item, idx) => {
        let Wrapper = 'div'
        let href = {}
        if (item.url) {
          Wrapper = 'a'
          href = { href: item.url }
        }
        return (
          <div className="popup-menu-item" key={`dir-itm-${idx}-${item.iconName}`}>
            <Wrapper
              className="popup-menu-item-wrapper"
              onClick={() => {
                item.handleUrl ? item.handleUrl() : item.onClick && item.onClick()
                triggerEvent(`ga/global/menu-navbar/${item.label}`)
              }}
              {...href}
            >
              <Container next>
                <div className="popup-menu-item-content">
                  {item.icon}
                  {!item.iconName && item.imageUrl && (
                    <img src={`${assetsUrl}/${item.imageUrl}`} alt="Profile Avatar Icon" />
                  )}
                  <Typography variant="subbody" component="p">
                    {item.name}
                  </Typography>
                  {item.isNew && <Badge variant="red">BARU</Badge>}
                </div>
              </Container>
            </Wrapper>
          </div>
          )
        })}
    </div>
    {isDOMAvailable && window.outerWidth >= 768 && document && (
      <Backdrop parent={document.body} onClick={close} onMouseEnter={close} />
    )}
    <style jsx>
      {`
        .popup-menu {
          position: absolute;
          width: 240px;
          z-index: 100;
          padding: 8px 0;
          top: 54px;
          right: 0;

          &-inner {
            background-color: #fff;
            box-shadow: 0 2px 12px 4px rgba(26, 52, 79, 0.2);
            border-radius: 10px;
            padding: 12px 0;
          }
          &-item {
            display: flex;
            align-items: center;
            padding: 8px 0;
            justify-content: flex-start;
            width: 100%;
            cursor: pointer;
            &:hover {
              background-color: #EBEEF3;
            }
          }
          &-item-wrapper {
            display: block;
            width: 100%;
            &:hover {
              text-decoration: none;
            }
          }
          &-item-content {
            display: flex;
            align-items: center;
            padding: 0 16px;
            :global(svg) {
                margin-right: 16px;
            }
            :global(.cmps-container, p) {
              flex-grow: 1;
            }
            :global(p) {
              line-height: 24px;
              color: #1A344F !important;
            }
            :global(img) {
              width: 24px;
              height: 24px;
              margin-right: 16px;
            }
          }
        }
      `}
    </style>
  </div>
)

export default PopupMenu
